import { fetchQuery } from '@/services/messaging/fetchQuery';

export function getAuthenticationConfiguration() {
  return fetchQuery("GetAuthenticationConfiguration");
}
